import { useQuery } from "@apollo/client";



































export const useDataClientQuery = useQuery;
